import { rebottle } from "../elements";
import type { BottleType, CanvasData } from "../schema";
import { INK, centred, doc, hairline } from "./kit";
import type { LabelTemplate } from "./types";

// Minimalist modern: one quiet name floating in white space.
function wine(): CanvasData {
  const b = "wine";
  return doc(b, INK["warm-white"], [
    centred(b, { text: "your name", font: "cormorant", size: 8, color: INK.charcoal, baseline: 48, tracking: 0.2 }),
    hairline(INK.charcoal, 45, 55, 20),
    centred(b, { text: "2026 · stellenbosch", font: "montserrat", size: 1.6, color: INK.charcoal, baseline: 90, tracking: 0.3 }),
  ]);
}

export const minimalModern: LabelTemplate = {
  key: "minimal-modern",
  name: "Minimalist",
  occasion: "modern",
  style: "Minimalist modern",
  description: "One quiet name in generous white space.",
  hasImageSlot: false,
  build: (bottle: BottleType) => (bottle === "wine" ? wine() : rebottle(wine(), bottle)),
};
